// extracted by mini-css-extract-plugin
export default {"pleaseChoose":"libraries-management-page_pleaseChoose__Ia1ZL"};